var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSolutions = function SvgSolutions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 80,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#solutions_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F2F4FF",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M39.568 79.154c21.3 0 38.567-17.268 38.567-38.568S60.868 2.018 39.568 2.018 1 19.285 1 40.586s17.267 38.568 38.568 38.568Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EA56D",
    stroke: "#3D4040",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m21.735 1-9.67 24.792 40.722 15.886 9.671-24.793z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#3D4040",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m29.08 8.114 23.452 9.165a4.714 4.714 0 0 0 2.676 6.098l-3.422 8.773a4.713 4.713 0 0 0-6.074 2.607l-23.451-9.15a4.714 4.714 0 0 0-2.7-6.036l-.284-.092 3.43-8.797.276.116a4.705 4.705 0 0 0 6.098-2.684"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EA56D",
    d: "M37.391 25.946a4.652 4.652 0 1 0 0-9.303 4.652 4.652 0 0 0 0 9.303M27.826 19.14a1.584 1.584 0 1 0 0-3.167 1.584 1.584 0 0 0 0 3.168"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#041B93",
    d: "M46.948 26.607a1.584 1.584 0 1 0 0-3.168 1.584 1.584 0 0 0 0 3.168"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#3D4040",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M60.426 15.395 6.8 30.328a3.837 3.837 0 0 0-2.667 4.726l11.486 41.25a3.837 3.837 0 0 0 4.725 2.667l53.628-14.933a3.837 3.837 0 0 0 2.667-4.725L65.15 18.063a3.837 3.837 0 0 0-4.725-2.668Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3D4040",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m68.958 32.742-24.606 6.852 4.032 14.48 24.606-6.851z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#041B93",
    d: "M53.847 47.737a3.46 3.46 0 1 0 0-6.92 3.46 3.46 0 0 0 0 6.92M13.009 51.035l5.936-1.653.492 1.745-3.845 1.061.592 2.138 3.26-.907.485 1.753-3.253.907.992 3.583-2.122.592zM20.576 48.929l5.898-1.646.484 1.746-3.768 1.053.516 1.853 3.214-.892.484 1.745-3.214.893.592 2.13 3.914-1.093.492 1.746-6.044 1.684zM28.488 46.722l5.898-1.646.492 1.753-3.776 1.046.516 1.853 3.214-.892.484 1.745-3.206.9.592 2.122 3.913-1.092.485 1.753-6.044 1.677zM38.036 52.742l.83-1.768c.797.397 1.706.51 2.576.323.892-.246 1.23-.715 1.077-1.261s-.77-.615-1.661-.723l-1.369-.169a2.8 2.8 0 0 1-2.598-1.984c-.423-1.537.63-3.137 2.59-3.683a4.55 4.55 0 0 1 3.36.37l-.707 1.606a3.22 3.22 0 0 0-2.153-.177c-.769.208-1.122.639-.976 1.161.146.523.83.6 1.745.693l1.33.146a2.644 2.644 0 0 1 2.569 1.983c.422 1.538-.508 3.222-2.753 3.845a5.45 5.45 0 0 1-3.86-.362"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#3D4040",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M64.525 77.107c7.567 0 13.701-6.135 13.701-13.702s-6.134-13.702-13.701-13.702-13.702 6.135-13.702 13.702 6.135 13.702 13.702 13.702Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1EA56D",
    d: "M56.25 58.246h2.123l2.306 4.398.892 1.938h.054a32 32 0 0 1-.261-3.214v-3.122h1.945v8.835h-2.091l-2.353-4.406-.892-1.93h-.062c.1.977.262 2.16.262 3.199v3.137h-1.946zM65.031 62.628c0-2.89 1.669-4.544 4.098-4.544 2.43 0 4.099 1.66 4.099 4.544s-1.661 4.614-4.099 4.614c-2.437 0-4.098-1.73-4.098-4.614m6.105 0c0-1.776-.769-2.822-2.007-2.822s-2.006 1.046-2.006 2.822.768 2.891 2.006 2.891 2.007-1.122 2.007-2.89"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "solutions_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h80v80H.5z"
  })))));
};
export default SvgSolutions;